
import { Design } from '../models/domain/design';
import { Stream } from '../models/domain/stream';

export class ClipboardCache {
	private static instance: ClipboardCache;

	static getInstance() {
		if (!ClipboardCache.instance) {
			ClipboardCache.instance = new ClipboardCache();
		}

		return ClipboardCache.instance;
	}

	type: string;
	copied_Cd: string;
	isCopied: boolean;
	nativeDbTyp_Id: number;
	stream: Stream;
	design: Design;
	persistTmp: any;
	copiedItems: Array<any>;
	obj_Ids: Array<number>;

	/**
    * ClipboardCache is a singleton class, so use ClipboardCache.getInstance() method instead of creating new ClipboardCache().
    */
	private constructor() {
		this.type = "";
		this.copied_Cd = "";
		this.isCopied = false;
		this.nativeDbTyp_Id = -1;
		this.stream = null;
		this.design = null;
		this.persistTmp = {};
		this.copiedItems = new Array<any>();
		this.obj_Ids = new Array<number>();
	}

	copy(copiedItems: Array<any>, type: string, isCopied: boolean): void {
		this.type = type;
		this.isCopied = isCopied;
		this.copiedItems.splice(0, this.copiedItems.length);
		this.copiedItems = copiedItems;
	}

	reset(): void {
		this.type = '';
		this.isCopied = false;
		this.copiedItems.splice(0, this.copiedItems.length);
	}

	setCopiedItems(copiedItemsTmp: Array<any>, isCopied: boolean, sortField: string) {
		this.isCopied = isCopied;
		this.copiedItems = copiedItemsTmp;

		// if (sortField == null) {
		// 	this.copiedItems = copiedItemsTmp;
		// 	return;
		// }

		// if (this.copiedItems.length > 0) {
		// 	this.copiedItems.splice(0, this.copiedItems.length);
		// }

		// for (let i: number = 0; i < copiedItemsTmp.length; i++) {
		// 	let j: number;
		// 	for (j = 0; j < this.copiedItems.length; j++) {
		// 		if (this.copiedItems[j][sortField] > copiedItemsTmp[i][sortField]) {
		// 			this.copiedItems.splice(j, 0, copiedItemsTmp[i]);
		// 			break;
		// 		}
		// 	}

		// 	if (this.copiedItems.length == j) {
		// 		this.copiedItems.push(copiedItemsTmp[i]);
		// 	}
		// }
	}

	setCopiedComments(obj_Ids: Array<number>, design: Design, persistTmp: any): void {
		this.copied_Cd = "CMNT";
		this.design = design;
		this.obj_Ids = obj_Ids;
		this.persistTmp = persistTmp;
		this.nativeDbTyp_Id = design.dxMp.nativeDbTyp_Id;
	}

	setCopiedTransforms(obj_Ids: Array<number>, design: Design, persistTmp: any): void {
		this.copied_Cd = "TXNS";
		this.design = design;
		this.obj_Ids = obj_Ids;
		this.persistTmp = persistTmp;
		this.nativeDbTyp_Id = design.dxMp.nativeDbTyp_Id;
	}

	updateCopiedTransforms(design: Design): void {
		this.design = design;
	}

	setCopiedTransformsAsEmpty(): void {
		this.copied_Cd = "";
		this.design = null;
		this.obj_Ids.splice(0, this.obj_Ids.length);
		this.nativeDbTyp_Id = -1;
	}

	setCopiedJobs(obj_Ids: Array<number>, stream: Stream, persistTmp: any): void {
		this.copied_Cd = "JOBS";
		this.stream = stream;
		this.obj_Ids = obj_Ids;
		this.persistTmp = persistTmp;
	}

	setCopiedStreamComments(obj_Ids: Array<number>, stream: Stream, persistTmp: any): void {
		this.copied_Cd = "CMNT";
		this.stream = stream;
		this.obj_Ids = obj_Ids;
		this.persistTmp = persistTmp;
	}

	updateCopiedJobs(stream: Stream): void {
		this.stream = stream;
	}

	setCopiedJobsAsEmpty(): void {
		this.copied_Cd = "";
		this.stream = null;
		this.obj_Ids.splice(0, this.obj_Ids.length);
		this.nativeDbTyp_Id = -1;
	}


	getCopiedItems(): Array<any> {
		let copiedItemsTmp: Array<any> = new Array<any>();
		for (let i: number = 0; i < this.copiedItems.length; i++) {
			copiedItemsTmp.push(this.copiedItems[i]);
		}

		if (!this.isCopied)
			this.setEmptyCopiedItems()

		return copiedItemsTmp;
	}

	removeTransform_Id(transform_Id: number): void {
		for (let i = 0; i < this.obj_Ids.length; i++) {
			if (this.obj_Ids[i] == transform_Id) {
				this.obj_Ids.splice(i, 1);
				break;
			}
		}

		if (this.obj_Ids.length == 0) {
			this.copied_Cd = "";
		}
	}

	removeJob_Id(job_Id: number): void {
		for (let i = 0; i < this.obj_Ids.length; i++) {
			if (this.obj_Ids[i] == job_Id) {
				this.obj_Ids.splice(i, 1);
				break;
			}
		}

		if (this.obj_Ids.length == 0) {
			this.copied_Cd = "";
		}
	}

	setEmptyCopiedItems(): void {
		this.copiedItems.splice(0, this.copiedItems.length);
	}
}